import React, {useEffect, useState} from 'react';
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle,
    TextField, Grid, Switch, FormControlLabel
} from '@material-ui/core';

const ProductDialog = ({ open, title, handleClose, submitCallback, dataObject }) => {
    const [formData, setFormData] = useState({
        product_key: '',
        label: '',
        description: '',
        icon: '',
        order_no: 0,
        is_active: true
    });

    useEffect(() => {
        if (dataObject) {
            setFormData({
                product_key: dataObject.product_key || '',
                label: dataObject.label || '',
                description: dataObject.description || '',
                icon: dataObject.icon || '',
                order_no: dataObject.order_no || 0,
                is_active: dataObject.is_active !== false // default true
            });
        }
    }, [dataObject]);

    const handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = () => {
        submitCallback({
            ...formData,
            ...(dataObject ? { _id: dataObject._id } : {}),
            order_no: parseInt(formData.order_no) || 0
        });
    };

    const isUpdate = !!(dataObject && dataObject._id);

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Product Key"
                            name="product_key"
                            value={formData.product_key}
                            onChange={handleChange}
                            variant="outlined"
                            disabled={isUpdate}
                            helperText="Unique identifier for the product (cannot be changed later)."
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Label"
                            name="label"
                            value={formData.label}
                            onChange={handleChange}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Description"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            variant="outlined"
                            multiline
                            rows={3}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label="Icon (optional)"
                            name="icon"
                            value={formData.icon}
                            onChange={handleChange}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label="Order No."
                            name="order_no"
                            type="number"
                            value={formData.order_no}
                            onChange={handleChange}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.is_active}
                                    onChange={handleChange}
                                    name="is_active"
                                    color="primary"
                                />
                            }
                            label="Globally Active (Kill-Switch)"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="default">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained">
                    {isUpdate ? 'Update' : 'Create'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ProductDialog;
